// TH 02/13/2017 -- Not really a service. Just a place to hold some common values used for
// scheduling.

export const
    DEFAULT_NEW_SHIFT_DURATION_MINS = 6 * 60,
    MINIMUM_RES_DURATION_MINS = 15,
    SAME_PIERGROUP_TRANSIT_MINS = 0,
    DIFFERENT_PIERGROUP_TRANSIT_MINS = 15;


// WEBPACK FOOTER //
// ./apps/common/services/scheduleConstants.ts